import { getCoordinates } from './getCoordinates';
import { IProps, IWithCoordinates } from './areaMap';

export const setCommonProps = (props: IProps, scale: number) => (e): IWithCoordinates => ({
  ...getCoordinates(e, scale),
  ...props,
});
